import { useEffect, useState } from "react";
import { CSS_CLASSES } from "../../../../css-classes";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Popup from "../../../../components/popup/Popup";
import { useNavigate } from "react-router-dom";
import {
  makeAjax,
  url,
  showMessage,
  respStatus,
} from "../../../../helpers/global_helper";

const HoverNav = (props) => {
  // set & get state
  const [maintainanceError, setMaintainanceError] = useState(false);
  const [commingSoonPopup, setCommingSoonPopup] = useState(false);
  const [specialCategoryGame, setSpecialCategoryGame] = useState([]);

  const [gameId, setGameId] = useState("");
  const [gameLaunchMessage, setGameLaunchMessage] = useState(false);
  const navigate = useNavigate();

  // Fetch subMenu Info
  const { providerSubMenuList } = useSelector((state) => ({
    providerSubMenuList: state.submenuListR.data,
  }));

  // Ajax call for game details
  const handleGameClick = (game) => {
    if (game.maintenance_mode) {
      setMaintainanceError(true);
      return;
    }
    // close window function
    const gameWindowData = JSON.parse(localStorage.getItem("gameWindow"));

    if (gameWindowData) {
      const existingWindow = window.open("", gameWindowData.id);
      if (existingWindow && !existingWindow.closed) {
        existingWindow.close();
        localStorage.removeItem("gameWindow"); // Clean up after closing
        setGameLaunchMessage(true);
        return;
      } else {
        localStorage.removeItem("gameWindow");
        setGameLaunchMessage(true);
        return;
      }
    }

    const payload = {
      game_id: game._id,
    };
    setGameId({ ...gameId, game_id: game._id });
    makeAjax(url.GP_API.playerRedirection, payload, url.GP_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          if (response.code == "internal_err") {
            const tempMessage = `${props.t("oops")}! ${props.t(
              "something_went_wrong"
            )}. ${props.t("we_are_working_on_fixing_it")}. ${props.t(
              "please_try_again_later"
            )}.`;
            showMessage(tempMessage, "playerRedirectionError");
          }
          if (response.code == "failed_system_error") {
            const tempMessage = `${props.t(
              "wait_for_5_min_and_check_again"
            )}.}`;
            showMessage(tempMessage, "playerRedirectionError");
          }
          if (response.code == "wait_5_min") {
            showMessage(response, "playerRedirectionError");
          }
          if (response.code == "game_under_maintenance") {
            setMaintainanceError(true);
            return;
          }
          if (response.code == "game_not_active") {
            setCommingSoonPopup(true);
            return;
          }

          if (response.code == "validation.invalid_token_error") {
            navigate("/register");
            return;
          }

          if (response.code != "validation_error") {
            showMessage(response);
            return;
          }
          showMessage(response);
          return;
        }

        //pg soft game data 7th feb 2024
        if (response?.data?.code === "bd200") {
          openGameTab(response?.data?.data, "pocket_game_soft");
        } else {
          openGameTab(response.data, "games");
        }
      }
    );
  };

  // Hot game list
  const getSpecialCategoryGame = () => {
    let payload = {
      category_code: props.code == "hot-games" ? "games" : props.code,
      provider_name: "",
      search_term: "",
    };
    makeAjax(url.USER_API.listProviderGame, payload, url.USER_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          if (response.code != "validation_error") {
            showMessage(response);
            return;
          }
          showMessage(response);
        }
        setSpecialCategoryGame(response.data.gameInfo);
      }
    );
  };

  // Use effect call
  useEffect(() => {
    if (
      ["card-games", "lottery", "dingdong", "hot-games"].includes(props.code)
    ) {
      getSpecialCategoryGame();
    }
  }, [props.code]);

  // Close maintaninace popup
  const handlePopup = () => {
    setMaintainanceError(false);
    setCommingSoonPopup(false);
    setGameLaunchMessage(false);
  };
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));

  // game lauch open tab function # added 1st august(12680)
  const openGameTab = (url, type) => {
    const gameUrl = url;
    const uniqueId = Date.now().toString(); // Simple unique ID
    let newWindow;

    if (type === "pocket_game_soft") {
      newWindow = window.open();
      newWindow.document.write(url);
    } else {
      newWindow = window.open(gameUrl, "_blank");
    }

    // Store the metadata in localStorage or sessionStorage
    const gameWindowData = {
      id: uniqueId,
      url: gameUrl,
    };

    // Convert to a JSON string for storage
    localStorage.setItem("gameWindow", JSON.stringify(gameWindowData));

    // Optional: store the unique ID in the window itself for later retrieval
    if (newWindow) {
      newWindow.window.name = uniqueId;
    }
  };

  return (
    <>
      {componentSetting?.["horizonatal-nav-bar"]?.["default-value"] ==
        "hover-listing" &&
        props.code != "home" && (
          <div
            className={
              componentSetting?.["horizonatal-nav-bar"]?.["default-value"]
            }
          >
            <div className={CSS_CLASSES.hoverMenu}>
              <div className="container games">
                <div className={CSS_CLASSES.menuItemsHover}>
                  {Object.values(providerSubMenuList).length > 0 &&
                    Object.values(providerSubMenuList).map(
                      (v) =>
                        Object.values(v).length > 0 &&
                        Object.values(v).map(
                          (obj) =>
                            obj.menu_code == props.code &&
                            !["hot-games"].includes(props.code) && (
                              <>
                                <div>
                                  <NavLink
                                    key={v}
                                    to={
                                      obj.menu_code +
                                      "/" +
                                      obj.tenant_provider_reco.provider_name
                                    }
                                  >
                                    {obj.maintenance_mode && (
                                      <div className="undermaintenance">
                                        {props.t("under_maintanance")}
                                      </div>
                                    )}
                                    <div key={v} className="item">
                                      {/* <span className="promo">{props.t(`${'promo'}`)}</span> */}
                                      {obj.menu_provider_media != null ? (
                                        <img
                                          loading="lazy"
                                          className="img-fluid"
                                          src={
                                            obj.ftp_path +
                                            obj.menu_provider_media.base_path +
                                            obj.menu_provider_media
                                              .system_file_name
                                          }
                                          alt={
                                            obj.tenant_provider_reco
                                              .provider_name
                                          }
                                        />
                                      ) : (
                                        <img
                                          loading="lazy"
                                          className="img-fluid"
                                          src={
                                            "/assets/images/default-images/providersm.png"
                                          }
                                          alt={
                                            obj.tenant_provider_reco
                                              .provider_name
                                          }
                                        />
                                      )}
                                      {obj.tenant_provider_reco.provider_name.split(
                                        ""
                                      ).length > 15 ? (
                                        <marquee>
                                          <h6 key={obj} className="item-name">
                                            {
                                              obj.tenant_provider_reco
                                                .provider_name
                                            }
                                          </h6>
                                        </marquee>
                                      ) : (
                                        <h6 key={obj} className="item-name">
                                          {
                                            obj.tenant_provider_reco
                                              .provider_name
                                          }
                                        </h6>
                                      )}
                                    </div>
                                  </NavLink>
                                </div>
                              </>
                            )
                        )
                    )}

                  {specialCategoryGame &&
                    ["card-games", "lottery", "dingdong", "hot-games"].includes(
                      props.code
                    ) &&
                    specialCategoryGame.length > 0 &&
                    specialCategoryGame.map((obj) => (
                      <>
                        {props.code != "lottery" ? (
                          <div
                            onClick={() => {
                              handleGameClick(obj);
                            }}
                          >
                            <NavLink key={obj}>
                              {obj.maintenance_mode && (
                                <div className="undermaintenance">
                                  {props.t("under_maintanance")}
                                </div>
                              )}
                              <div key={obj} className="item">
                                {obj.is_hot_game ? (
                                  <span className="promo">{"Hot"}</span>
                                ) : (
                                  ""
                                )}
                                {obj.game_assets_media != null ? (
                                  <img
                                    loading="lazy"
                                    className="img-fluid"
                                    src={
                                      obj.ftp_path +
                                      obj.game_assets_media.base_path +
                                      obj.game_assets_media.system_file_name
                                    }
                                    alt={obj.name}
                                  />
                                ) : (
                                  <img
                                    loading="lazy"
                                    className="img-fluid"
                                    src={
                                      "/assets/images/default-images/game.png"
                                    }
                                    alt={obj.name}
                                  />
                                )}
                                {obj.name.split("").length > 15 ? (
                                  <marquee>
                                    <h6 key={obj} className="item-name">
                                      {obj.name}
                                    </h6>
                                  </marquee>
                                ) : (
                                  <h6 key={obj} className="item-name">
                                    {obj.name}
                                  </h6>
                                )}
                              </div>
                            </NavLink>
                          </div>
                        ) : (
                          <>
                            <div>
                              <NavLink
                                key={obj}
                                to={
                                  "lottery" +
                                  "/" +
                                  obj.provider.tenant_provider.provider_name
                                }
                              >
                                {obj.maintenance_mode && (
                                  <div className="undermaintenance">
                                    {props.t("under_maintanance")}
                                  </div>
                                )}
                                <div key={obj} className="item">
                                  {obj.is_hot_game ? (
                                    <span className="promo">{"Hot"}</span>
                                  ) : (
                                    ""
                                  )}
                                  {obj.game_assets_media != null ? (
                                    <img
                                      loading="lazy"
                                      className="img-fluid"
                                      src={
                                        obj.ftp_path +
                                        obj.game_assets_media.base_path +
                                        obj.game_assets_media.system_file_name
                                      }
                                      alt={obj.name}
                                    />
                                  ) : (
                                    <img
                                      loading="lazy"
                                      className="img-fluid"
                                      src={
                                        "/assets/images/default-images/game.png"
                                      }
                                      alt={obj.name}
                                    />
                                  )}
                                  {obj.name.split("").length > 15 ? (
                                    <marquee>
                                      <h6 key={obj} className="item-name">
                                        {obj.name}
                                      </h6>
                                    </marquee>
                                  ) : (
                                    <h6 key={obj} className="item-name">
                                      {obj.name}
                                    </h6>
                                  )}
                                </div>
                              </NavLink>
                            </div>
                          </>
                        )}
                      </>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}

      {maintainanceError && (
        <Popup handlePoup={handlePopup} providerMaintainance />
      )}
      {commingSoonPopup && <Popup handlePoup={handlePopup} commingSoonGame />}
      {gameLaunchMessage && (
        <Popup handlePoup={handlePopup} launchGameMessage />
      )}
    </>
  );
};

HoverNav.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(HoverNav);
